module.exports = __webpack_public_path__ + "static/41-d82c60d58196bd132d2a4eced891bb49.webp";